import { Routes } from '@angular/router';
import { provideRouter } from '@angular/router';
import { PrivacyPolicyComponent } from './components/privacy-policy/privacy-policy';
import { TermsConditionComponent } from './components/terms-condition/terms-condition';

export const routes: Routes = [
  { path: 'privacy-policy', component: PrivacyPolicyComponent },
  { path: 'terms-and-conditions', component: TermsConditionComponent },
  {
    path: '',
    redirectTo: 'feature-module',
    pathMatch: 'full',
  },
  {
    path: '',
    loadChildren: () =>
      import('./feature-module/feature-module.module').then(
        (m) => m.FeatureModuleModule
      ),
  },
  {
    path: 'error404',
    loadComponent: () =>
      import('./components/error404/error404').then((m) => m.Error404Component),
  },
  {
    path: '**',
    redirectTo: 'error404',
  },
];

// Provide this in main.ts
export const APP_ROUTES_PROVIDER = provideRouter(routes);
